module.exports = __webpack_public_path__ + "img/2ab9dde4-0420-4594-b875-a8465741b767.94b6d302.webp";